<div class="login-page vh-100 bg-secondary">
  <div class="container">
    <div class="row py-5">
      <div class="col-12 col-md-4 offset-md-4 text-center d-flex justify-content-center">
        <img class="d-block" style="width: 450px;" src="assets/images/logo.svg" alt="hello-one Enterprise">
      </div>
      <div class="col-12 col-md-6 offset-md-3 mt-5">
        <div class="card">
          <div class="card-body p-4">
            <a [routerLink]="'/auth/help'" class="position-absolute" style="top: 10px; right: 10px;">
              <i class="fa-solid fa-circle-question" style="font-size: 23px;"></i>
            </a>
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
